import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "./Navbar";

const EMAIL = "vmdpproject@gmail.com";
const PIVA = "10990261215";
const UPDATED = "Giugno 2026";

/* ─── Sezione testo legale ─── */
function Section({ n, title, children }) {
  return (
    <div
      style={{
        marginBottom: "2.75rem",
        paddingBottom: "2.75rem",
        borderBottom: "1px solid var(--color-border)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "1rem",
        }}
      >
        <span
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "0.7rem",
            fontWeight: 500,
            color: "var(--color-accent-mid)",
            background: "rgba(124,58,237,0.1)",
            border: "1px solid rgba(124,58,237,0.22)",
            borderRadius: "6px",
            padding: "3px 9px",
            flexShrink: 0,
          }}
        >
          {String(n).padStart(2, "0")}
        </span>
        <h2
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 700,
            fontSize: "clamp(1.3rem, 2.5vw, 1.6rem)",
            color: "var(--color-text)",
            letterSpacing: "-0.01em",
            margin: 0,
          }}
        >
          {title}
        </h2>
      </div>
      <div
        style={{
          color: "var(--color-text-2)",
          fontSize: "1rem",
          lineHeight: 1.85,
        }}
      >
        {children}
      </div>
    </div>
  );
}

const linkStyle = {
  color: "var(--color-accent-mid)",
  textDecoration: "underline",
  textUnderlineOffset: "3px",
};
const ulStyle = {
  paddingLeft: "1.25rem",
  margin: "0.75rem 0",
  display: "flex",
  flexDirection: "column",
  gap: "0.4rem",
};

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
        style={{ background: "var(--color-bg)", minHeight: "100vh" }}
      >
        {/* ── Hero ── */}
        <section
          style={{
            paddingTop: "68px",
            background:
              "linear-gradient(180deg, rgba(124,58,237,0.08) 0%, transparent 100%)",
            borderBottom: "1px solid var(--color-border)",
          }}
        >
          <div className="container" style={{ padding: "4rem 1.75rem 3rem" }}>
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-accent-mid)",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                display: "block",
                marginBottom: "1rem",
              }}
            >
              {"// privacy policy"}
            </span>
            <h1
              style={{
                fontFamily: "var(--font-display)",
                fontWeight: 800,
                fontSize: "clamp(2.2rem, 5vw, 3.2rem)",
                letterSpacing: "-0.03em",
                lineHeight: 1.1,
                marginBottom: "1rem",
              }}
            >
              Privacy{" "}
              <span
                style={{
                  background: "var(--gradient-text)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Policy
              </span>
            </h1>
            <p
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-muted)",
              }}
            >
              VMDProject · vmdproject.com · Ultimo aggiornamento: {UPDATED}
            </p>
          </div>
        </section>

        {/* ── Contenuto ── */}
        <div className="container" style={{ padding: "3rem 1.75rem 5rem" }}>
          {/* Intro card */}
          <div
            style={{
              background: "rgba(124,58,237,0.06)",
              border: "1px solid rgba(124,58,237,0.2)",
              backdropFilter: "blur(12px)",
              borderRadius: "var(--radius-lg)",
              padding: "1.5rem 1.75rem",
              marginBottom: "3rem",
              color: "var(--color-text-2)",
              fontSize: "1rem",
              lineHeight: 1.8,
            }}
          >
            La presente Privacy Policy descrive le modalità di raccolta,
            utilizzo e protezione dei dati personali degli utenti che visitano
            il sito{" "}
            <strong style={{ color: "var(--color-text)" }}>
              vmdproject.com
            </strong>{" "}
            e utilizzano il modulo di contatto. Informativa redatta ai sensi del
            Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003.
          </div>

          <Section n={1} title="Titolare del Trattamento">
            <strong style={{ color: "var(--color-text)" }}>VMDProject</strong>
            <br />
            Sede: Napoli, Italia
            <br />
            P.IVA: {PIVA}
            <br />
            Email:{" "}
            <a href={`mailto:${EMAIL}`} style={linkStyle}>
              {EMAIL}
            </a>
            <br />
            <br />
            Per qualsiasi questione relativa al trattamento dei tuoi dati
            personali puoi scrivere direttamente al Titolare all'indirizzo email
            indicato.
          </Section>

          <Section n={2} title="Dati Raccolti e Finalità del Trattamento">
            <strong style={{ color: "var(--color-text)" }}>
              a) Modulo di contatto e richieste di collaborazione
            </strong>
            <br />
            Quando compili il modulo di contatto raccogliamo i seguenti dati:
            <ul style={ulStyle}>
              <li>Nome e cognome</li>
              <li>Indirizzo email</li>
              <li>
                Tipo di richiesta, descrizione del progetto, budget e
                tempistiche
              </li>
            </ul>
            I dati vengono salvati su{" "}
            <strong style={{ color: "var(--color-text)" }}>
              Firebase Firestore
            </strong>{" "}
            (Google) e inviati tramite{" "}
            <strong style={{ color: "var(--color-text)" }}>EmailJS</strong> al
            solo scopo di rispondere alla tua richiesta. La base giuridica è il
            consenso espresso compilando e inviando il modulo.
            <br />
            <br />
            <strong style={{ color: "var(--color-text)" }}>
              b) Dati di navigazione
            </strong>
            <br />
            Raccogliamo dati tecnici anonimi tramite{" "}
            <strong style={{ color: "var(--color-text)" }}>
              Firebase Analytics
            </strong>
            :
            <ul style={ulStyle}>
              <li>Indirizzo IP (anonimizzato)</li>
              <li>Browser e dispositivo utilizzato</li>
              <li>Pagine visitate e durata della visita</li>
              <li>Provenienza geografica approssimativa</li>
            </ul>
            Dati trattati in forma aggregata e anonima per migliorare il sito.
            Base giuridica: legittimo interesse.
            <br />
            <br />
            <strong style={{ color: "var(--color-text)" }}>c) Cookie</strong>
            <br />
            Il sito utilizza cookie tecnici necessari al funzionamento. Il
            consenso viene gestito tramite il banner cookie integrato nel sito.
            Puoi modificare le tue preferenze in qualsiasi momento tramite il
            banner.
          </Section>

          <Section n={3} title="Modalità e Luogo del Trattamento">
            I dati raccolti tramite il modulo di contatto sono trasmessi in
            forma cifrata (TLS/HTTPS) ai servizi EmailJS e Firebase (Google). I
            dati analitici sono elaborati da Google su infrastruttura cloud
            internazionale. Il Titolare adotta misure tecniche e organizzative
            adeguate per proteggere i dati da accessi non autorizzati.
          </Section>

          <Section n={4} title="Periodo di Conservazione">
            <ul style={ulStyle}>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Richieste di contatto / collaborazione:
                </strong>{" "}
                conservati per il tempo necessario a evadere la richiesta e
                comunque non oltre 24 mesi.
              </li>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Dati analitici:
                </strong>{" "}
                aggregati e anonimi, conservati secondo le politiche di Google
                Analytics (default: 26 mesi).
              </li>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Cookie tecnici:
                </strong>{" "}
                durata indicata nella configurazione del cookie banner.
              </li>
            </ul>
          </Section>

          <Section n={5} title="Diritti dell'Utente (GDPR)">
            Ai sensi degli articoli 15–22 del GDPR hai il diritto di:
            <ul style={ulStyle}>
              <li>
                <strong style={{ color: "var(--color-text)" }}>Accesso:</strong>{" "}
                ottenere conferma che siano trattati dati che ti riguardano e
                riceverne copia.
              </li>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Rettifica:
                </strong>{" "}
                richiedere la correzione di dati inesatti.
              </li>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Cancellazione:
                </strong>{" "}
                richiedere la cancellazione dei tuoi dati ("diritto all'oblio").
              </li>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Limitazione:
                </strong>{" "}
                richiedere la limitazione del trattamento in determinate
                circostanze.
              </li>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Portabilità:
                </strong>{" "}
                ricevere i tuoi dati in formato strutturato e leggibile da
                macchina.
              </li>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Opposizione:
                </strong>{" "}
                opporti al trattamento basato sul legittimo interesse.
              </li>
              <li>
                <strong style={{ color: "var(--color-text)" }}>
                  Revoca del consenso:
                </strong>{" "}
                in qualsiasi momento, senza pregiudizio per la liceità del
                trattamento precedente.
              </li>
            </ul>
            Per esercitare questi diritti scrivi a{" "}
            <a href={`mailto:${EMAIL}`} style={linkStyle}>
              {EMAIL}
            </a>
            . Hai inoltre il diritto di proporre reclamo al{" "}
            <strong style={{ color: "var(--color-text)" }}>
              Garante per la Protezione dei Dati Personali
            </strong>{" "}
            (
            <a
              href="https://www.garanteprivacy.it"
              target="_blank"
              rel="noreferrer"
              style={linkStyle}
            >
              garanteprivacy.it
            </a>
            ).
          </Section>

          <Section n={6} title="Trasferimento Dati Extra-UE">
            Alcuni servizi terzi utilizzati (EmailJS, Google/Firebase) trattano
            dati in paesi extra-UE. Tali trasferimenti avvengono nel rispetto
            delle garanzie previste dal GDPR (clausole contrattuali standard o
            meccanismi equivalenti).
          </Section>

          <Section n={7} title="Privacy Policy dei Singoli Prodotti">
            Ogni applicazione sviluppata da VMDProject dispone di una propria
            Privacy Policy specifica:
            <ul style={ulStyle}>
              <li>
                <Link to="/icoach/policy" style={linkStyle}>
                  iCoach — Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/crewboat/policy" style={linkStyle}>
                  CrewBoat — Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/ipairly/policy" style={linkStyle}>
                  iPairly — Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/veyro/policy" style={linkStyle}>
                  Veyro — Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/veyro-trainer/policy" style={linkStyle}>
                  Veyro Trainer — Privacy Policy
                </Link>
              </li>
            </ul>
          </Section>

          <Section n={8} title="Modifiche alla Privacy Policy">
            VMDProject si riserva il diritto di aggiornare la presente Privacy
            Policy in qualsiasi momento. Le modifiche saranno pubblicate su
            questa pagina con aggiornamento della data. Per modifiche
            sostanziali verrà data comunicazione tramite banner nel sito.
          </Section>

          <Section n={9} title="Contatti">
            Per qualsiasi domanda relativa a questa Privacy Policy:
            <br />
            <br />
            <strong style={{ color: "var(--color-text)" }}>VMDProject</strong> —
            Napoli, Italia
            <br />
            P.IVA: {PIVA}
            <br />
            Email:{" "}
            <a href={`mailto:${EMAIL}`} style={linkStyle}>
              {EMAIL}
            </a>
          </Section>

          {/* Navigazione legale */}
          {/* <div style={{
            display: 'flex', gap: '1rem', flexWrap: 'wrap',
            justifyContent: 'space-between', alignItems: 'center',
            marginTop: '1rem', paddingTop: '2.5rem',
            borderTop: '1px solid var(--color-border)',
          }}>
            <Link to="/" className="btn-primary">← Torna alla Home</Link>
            <Link to="/terms-and-conditions" style={linkStyle}>Termini e Condizioni →</Link>
          </div>
 */}
        </div>

        {/* ─── Footer ─── */}
        <footer
          style={{
            borderTop: "1px solid var(--color-border)",
            padding: "2rem 0",
          }}
        >
          <div
            className="container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <span
              style={{
                fontFamily: "var(--font-display)",
                fontWeight: 700,
                fontSize: "0.95rem",
              }}
            >
              VMDProject
            </span>
            <div style={{ display: "flex", gap: "1.5rem" }}>
              <Link
                to="/policy"
                style={{ fontSize: "0.9rem", color: "var(--color-accent-mid)" }}
              >
                Privacy
              </Link>
              <Link
                to="/terms-and-conditions"
                style={{
                  fontSize: "0.9rem",
                  color: "var(--color-muted)",
                  transition: "color 0.3s",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.color = "var(--color-text)")
                }
                onMouseLeave={(e) =>
                  (e.target.style.color = "var(--color-muted)")
                }
              >
                Termini
              </Link>
            </div>
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.82rem",
                color: "var(--color-muted)",
              }}
            >
              © {new Date().getFullYear()} VMDProject
            </span>
          </div>
        </footer>
      </motion.main>
    </>
  );
}
